import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SectionHeader = ({ title, description }) => {
  return (
    <Styles.Container>
      <Text type="titleS">{title}</Text>
      {description && <Text type="bodyMRegular">{description}</Text>}
    </Styles.Container>
  )
}

export default SectionHeader
